// Mock data para el blog de ganar dinero online

export const categories = [
  { id: 1, name: 'Apps', slug: 'apps', description: 'Aplicaciones para generar ingresos' },
  { id: 2, name: 'Inteligencia Artificial', slug: 'inteligencia-artificial', description: 'IA y monetización' },
  { id: 3, name: 'Negocios Online', slug: 'negocios-online', description: 'Emprendimiento digital' },
  { id: 4, name: 'Consejos', slug: 'consejos', description: 'Tips y estrategias financieras' }
];

export const articles = [
  {
    id: 1,
    title: 'Las 10 Mejores Apps para Ganar Dinero en 2025',
    slug: 'mejores-apps-ganar-dinero-2025',
    excerpt: 'Descubre las aplicaciones móviles más rentables que te permiten generar ingresos pasivos desde tu smartphone.',
    content: `<p>En 2025, la economía móvil ha evolucionado significativamente, ofreciendo múltiples oportunidades para generar ingresos adicionales desde tu smartphone. Estas son las mejores aplicaciones verificadas:</p>

<h2>1. Apps de Inversión Automatizada</h2>
<p>Plataformas como Acorns y Robinhood permiten invertir pequeñas cantidades automáticamente. Perfectas para principiantes que quieren hacer crecer su dinero sin conocimientos avanzados.</p>

<h2>2. Apps de Cashback y Recompensas</h2>
<p>Rakuten y Honey ofrecen devoluciones de dinero en compras cotidianas. Puedes ganar entre 5-20% de cashback en miles de tiendas online.</p>

<h2>3. Apps de Freelancing</h2>
<p>Fiverr y Upwork conectan freelancers con clientes globales. Ideal para diseñadores, escritores, programadores y consultores.</p>

<h2>Conclusión</h2>
<p>Estas aplicaciones son herramientas legítimas para generar ingresos adicionales. La clave está en la consistencia y elegir las que mejor se adapten a tus habilidades.</p>`,
    category: 'apps',
    categoryName: 'Apps',
    author: 'María González',
    date: '2025-01-10',
    image: 'https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800&q=80',
    tags: ['apps', 'ingresos pasivos', 'móvil', 'dinero extra'],
    readTime: '5 min',
    featured: true
  },
  {
    id: 2,
    title: 'Cómo ChatGPT y la IA Pueden Multiplicar tus Ingresos',
    slug: 'chatgpt-ia-multiplicar-ingresos',
    excerpt: 'Estrategias prácticas para usar inteligencia artificial en tu negocio y aumentar tu productividad hasta un 300%.',
    content: `<p>La inteligencia artificial ha democratizado el acceso a herramientas que antes solo estaban disponibles para grandes empresas. Aquí te muestro cómo aprovecharlas:</p>

<h2>Automatización de Contenido</h2>
<p>ChatGPT puede ayudarte a crear contenido para blogs, redes sociales y marketing en minutos. Esto te permite escalar tu negocio sin contratar un equipo grande.</p>

<h2>Generación de Imágenes con IA</h2>
<p>Herramientas como Midjourney y DALL-E te permiten crear diseños profesionales sin conocimientos de diseño gráfico.</p>

<h2>Asistentes Virtuales Inteligentes</h2>
<p>Automatiza respuestas a clientes, gestión de citas y tareas administrativas con chatbots de IA.</p>

<h2>Oportunidades Reales</h2>
<p>Freelancers están ganando $5,000-$10,000 mensuales ofreciendo servicios potenciados por IA: redacción, diseño, análisis de datos y consultoría.</p>`,
    category: 'inteligencia-artificial',
    categoryName: 'Inteligencia Artificial',
    author: 'Carlos Ruiz',
    date: '2025-01-08',
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80',
    tags: ['IA', 'ChatGPT', 'automatización', 'productividad'],
    readTime: '7 min',
    featured: true
  },
  {
    id: 3,
    title: 'Dropshipping en 2025: Guía Completa para Principiantes',
    slug: 'dropshipping-2025-guia-completa',
    excerpt: 'Todo lo que necesitas saber para iniciar tu tienda online sin inventario y generar ingresos desde el primer mes.',
    content: `<p>El dropshipping sigue siendo uno de los modelos de negocio más accesibles para emprendedores. Aquí está tu guía paso a paso:</p>

<h2>¿Qué es el Dropshipping?</h2>
<p>Es un modelo donde vendes productos sin mantener inventario. El proveedor envía directamente al cliente.</p>

<h2>Pasos para Empezar</h2>
<p>1. Elige un nicho rentable (productos con margen del 30-50%)</p>
<p>2. Encuentra proveedores confiables en AliExpress o CJ Dropshipping</p>
<p>3. Crea tu tienda en Shopify o WooCommerce</p>
<p>4. Implementa marketing en Facebook e Instagram Ads</p>

<h2>Costos Iniciales</h2>
<p>Puedes empezar con $500-$1,000 USD para dominio, hosting, y publicidad inicial.</p>

<h2>Expectativas Realistas</h2>
<p>Los primeros 3 meses son de aprendizaje. Después puedes generar $2,000-$5,000 mensuales con la estrategia correcta.</p>`,
    category: 'negocios-online',
    categoryName: 'Negocios Online',
    author: 'Laura Martínez',
    date: '2025-01-05',
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80',
    tags: ['dropshipping', 'ecommerce', 'emprendimiento', 'tienda online'],
    readTime: '10 min',
    featured: true
  },
  {
    id: 4,
    title: '7 Errores Financieros que Debes Evitar al Trabajar Online',
    slug: 'errores-financieros-trabajo-online',
    excerpt: 'Aprende a gestionar tus ingresos digitales correctamente y evita los errores más comunes que cometen los emprendedores.',
    content: `<p>Trabajar online ofrece libertad, pero también requiere disciplina financiera. Evita estos errores críticos:</p>

<h2>1. No Separar Finanzas Personales y de Negocio</h2>
<p>Abre una cuenta bancaria exclusiva para tu negocio. Esto facilita la contabilidad y el pago de impuestos.</p>

<h2>2. No Ahorrar para Impuestos</h2>
<p>Como autónomo, debes reservar 25-30% de tus ingresos para impuestos.</p>

<h2>3. Gastar en Herramientas Innecesarias</h2>
<p>Comienza con herramientas gratuitas o económicas. Escala cuando tengas ingresos consistentes.</p>

<h2>4. No Diversificar Fuentes de Ingreso</h2>
<p>Depender de un solo cliente o plataforma es arriesgado. Crea múltiples fuentes de ingresos.</p>

<h2>5. Ignorar la Planificación a Largo Plazo</h2>
<p>Invierte en jubilación y crea un fondo de emergencia de 6 meses.</p>`,
    category: 'consejos',
    categoryName: 'Consejos',
    author: 'Roberto Silva',
    date: '2025-01-03',
    image: 'https://images.unsplash.com/photo-1559526324-593bc073d938?w=800&q=80',
    tags: ['finanzas', 'consejos', 'gestión', 'errores comunes'],
    readTime: '6 min',
    featured: false
  },
  {
    id: 5,
    title: 'Marketing de Afiliados: Cómo Generar $3,000 Mensuales',
    slug: 'marketing-afiliados-3000-mensuales',
    excerpt: 'Estrategia comprobada para construir un negocio de afiliados rentable desde cero, incluso sin audiencia previa.',
    content: `<p>El marketing de afiliados es una de las formas más escalables de generar ingresos online. Aquí está la estrategia exacta:</p>

<h2>Selección de Nicho</h2>
<p>Elige un nicho con productos de alto valor ($100+) y comisiones del 20-50%. Ejemplos: software, cursos online, hosting.</p>

<h2>Construcción de Audiencia</h2>
<p>Crea contenido valioso en YouTube, blog o Instagram sobre el nicho elegido. Enfócate en resolver problemas reales.</p>

<h2>Programas de Afiliados Recomendados</h2>
<p>- Amazon Associates (4-10% comisión)</p>
<p>- ClickBank (50-75% comisión en productos digitales)</p>
<p>- ShareASale (variado según producto)</p>

<h2>Estrategia de Contenido</h2>
<p>Crea reseñas honestas, tutoriales y comparativas. El contenido evergreen genera ingresos pasivos durante años.</p>

<h2>Timeline Realista</h2>
<p>Mes 1-3: Construcción de contenido ($0-$200)</p>
<p>Mes 4-6: Primeras ventas consistentes ($500-$1,500)</p>
<p>Mes 7-12: Escalamiento ($2,000-$5,000)</p>`,
    category: 'negocios-online',
    categoryName: 'Negocios Online',
    author: 'Ana López',
    date: '2024-12-28',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
    tags: ['afiliados', 'marketing', 'ingresos pasivos', 'estrategia'],
    readTime: '8 min',
    featured: false
  },
  {
    id: 6,
    title: 'Freelancing: De $0 a $5,000 en 90 Días',
    slug: 'freelancing-0-a-5000-en-90-dias',
    excerpt: 'Plan de acción detallado para conseguir tus primeros clientes de alto valor y construir un negocio freelance rentable.',
    content: `<p>El freelancing es la forma más rápida de empezar a ganar dinero online. Esta es la estrategia que funcionó para mí y cientos de estudiantes:</p>

<h2>Días 1-30: Preparación y Posicionamiento</h2>
<p>Define tu servicio específico (diseño web, copywriting, gestión de redes sociales). Crea un portfolio con 2-3 proyectos (incluso pro-bono).</p>

<h2>Días 31-60: Adquisición de Clientes</h2>
<p>Plataformas recomendadas: Upwork, Fiverr (inicialmente), LinkedIn (largo plazo).</p>
<p>Envía 10 propuestas personalizadas diarias. Tasa de conversión esperada: 5-10%.</p>

<h2>Días 61-90: Escalamiento</h2>
<p>Aumenta tus tarifas 30%. Enfócate en clientes recurrentes. Automatiza procesos con plantillas y herramientas.</p>

<h2>Tarifas Realistas</h2>
<p>Principiante: $15-$25/hora</p>
<p>Intermedio: $40-$75/hora</p>
<p>Experto: $100-$200/hora</p>

<h2>Clave del Éxito</h2>
<p>Especialízate, entrega más de lo prometido, y construye relaciones a largo plazo.</p>`,
    category: 'consejos',
    categoryName: 'Consejos',
    author: 'Diego Fernández',
    date: '2024-12-25',
    image: 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=800&q=80',
    tags: ['freelancing', 'clientes', 'tarifas', 'estrategia'],
    readTime: '9 min',
    featured: false
  },
  {
    id: 7,
    title: 'Herramientas de IA Gratuitas para Emprendedores',
    slug: 'herramientas-ia-gratuitas-emprendedores',
    excerpt: 'Lista completa de herramientas de inteligencia artificial sin costo que pueden transformar tu productividad.',
    content: `<p>No necesitas grandes presupuestos para acceder a herramientas de IA poderosas. Estas son las mejores opciones gratuitas:</p>

<h2>Para Contenido Escrito</h2>
<p><strong>ChatGPT Free:</strong> Escritura, brainstorming, investigación</p>
<p><strong>Notion AI:</strong> Organización y resúmenes de documentos</p>
<p><strong>Grammarly:</strong> Corrección y mejora de textos en inglés</p>

<h2>Para Diseño Visual</h2>
<p><strong>Canva AI:</strong> Diseños automáticos y plantillas inteligentes</p>
<p><strong>Remove.bg:</strong> Eliminar fondos de imágenes</p>
<p><strong>Bing Image Creator:</strong> Generación de imágenes con DALL-E</p>

<h2>Para Productividad</h2>
<p><strong>Otter.ai:</strong> Transcripción de reuniones</p>
<p><strong>Copy.ai:</strong> 100 generaciones gratuitas mensuales</p>
<p><strong>Tome:</strong> Presentaciones automáticas</p>

<h2>Para Marketing</h2>
<p><strong>ChatGPT + Zapier:</strong> Automatizaciones básicas</p>
<p><strong>Simplified:</strong> Contenido para redes sociales</p>

<h2>Consejo Pro</h2>
<p>Combina estas herramientas en un flujo de trabajo integrado para maximizar resultados sin invertir dinero.</p>`,
    category: 'inteligencia-artificial',
    categoryName: 'Inteligencia Artificial',
    author: 'Patricia Moreno',
    date: '2024-12-20',
    image: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=800&q=80',
    tags: ['herramientas', 'IA', 'gratuito', 'productividad'],
    readTime: '5 min',
    featured: false
  },
  {
    id: 8,
    title: 'Print on Demand: Negocio sin Inventario en 2025',
    slug: 'print-on-demand-negocio-sin-inventario',
    excerpt: 'Cómo crear y vender productos personalizados sin inversión inicial ni manejo de stock.',
    content: `<p>El Print on Demand (POD) permite vender camisetas, tazas, posters y más sin inventario. Es perfecto para creativos y emprendedores:</p>

<h2>¿Cómo Funciona?</h2>
<p>Creas diseños → Subes a plataforma POD → Cliente compra → Se imprime y envía automáticamente → Recibes ganancia</p>

<h2>Mejores Plataformas</h2>
<p><strong>Printful:</strong> Integración con Shopify, calidad premium</p>
<p><strong>Printify:</strong> Más opciones de productos, precios competitivos</p>
<p><strong>Redbubble:</strong> Marketplace integrado, sin necesidad de marketing inicial</p>

<h2>Nichos Rentables 2025</h2>
<p>- Frases motivacionales para emprendedores</p>
<p>- Diseños de mascotas personalizadas</p>
<p>- Arte digital minimalista</p>
<p>- Temáticas de profesiones específicas</p>

<h2>Inversión Inicial</h2>
<p>$0-$200 para diseños profesionales (o crea los tuyos con Canva)</p>

<h2>Expectativas de Ingresos</h2>
<p>Principiante: $200-$500/mes</p>
<p>Con marketing: $1,000-$3,000/mes</p>
<p>Nicho consolidado: $5,000+/mes</p>

<h2>Clave del Éxito</h2>
<p>Diseños únicos + nicho específico + marketing en Pinterest/Instagram</p>`,
    category: 'negocios-online',
    categoryName: 'Negocios Online',
    author: 'Javier Castro',
    date: '2024-12-18',
    image: 'https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=800&q=80',
    tags: ['print on demand', 'diseño', 'ecommerce', 'creatividad'],
    readTime: '7 min',
    featured: false
  },
  {
    id: 9,
    title: 'YouTube sin Mostrar tu Cara: $2,000 Mensuales',
    slug: 'youtube-sin-mostrar-cara-2000-mensuales',
    excerpt: 'Estrategias probadas para monetizar YouTube con videos faceless y construir un canal rentable.',
    content: `<p>No necesitas aparecer en cámara para tener éxito en YouTube. Miles de canales faceless generan ingresos significativos:</p>

<h2>Formatos Faceless Rentables</h2>
<p><strong>Tops y Listas:</strong> "Top 10 apps para ganar dinero"</p>
<p><strong>Tutoriales con Screen Recording:</strong> Software, apps, tutoriales</p>
<p><strong>Videos de Animación:</strong> Usando herramientas como Vyond o Doodly</p>
<p><strong>Compilaciones:</strong> Con uso justo de contenido</p>

<h2>Herramientas Necesarias</h2>
<p>- Invideo AI o Pictory: Creación de videos con IA</p>
<p>- ElevenLabs: Voz en off realista</p>
<p>- Canva: Miniaturas atractivas</p>
<p>- TubeBuddy: Optimización SEO</p>

<h2>Monetización</h2>
<p>1. AdSense (requiere 1,000 subs y 4,000 horas)</p>
<p>2. Marketing de afiliados (inmediato)</p>
<p>3. Sponsorships (con 10,000+ subs)</p>

<h2>Nichos Probados</h2>
<p>- Tecnología y gadgets</p>
<p>- Finanzas personales</p>
<p>- Productividad y desarrollo personal</p>
<p>- Historia y curiosidades</p>

<h2>Timeline Realista</h2>
<p>Mes 1-3: 100-500 suscriptores ($0-$50)</p>
<p>Mes 4-8: 1,000-5,000 suscriptores ($500-$1,000)</p>
<p>Mes 9-12: 10,000+ suscriptores ($2,000-$5,000)</p>`,
    category: 'apps',
    categoryName: 'Apps',
    author: 'Sandra Romero',
    date: '2024-12-15',
    image: 'https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?w=800&q=80',
    tags: ['YouTube', 'video', 'monetización', 'faceless'],
    readTime: '8 min',
    featured: false
  },
  {
    id: 10,
    title: 'Trading de Criptomonedas para Principiantes 2025',
    slug: 'trading-criptomonedas-principiantes-2025',
    excerpt: 'Guía segura para empezar en el mundo crypto sin perder dinero en el intento. Estrategias conservadoras y realistas.',
    content: `<p>Las criptomonedas ofrecen oportunidades, pero también riesgos. Esta guía te ayudará a comenzar de forma segura:</p>

<h2>Advertencia Inicial</h2>
<p>Solo invierte dinero que puedas permitirte perder. El trading crypto es de alto riesgo.</p>

<h2>Exchanges Confiables</h2>
<p><strong>Binance:</strong> Más opciones, fees bajos</p>
<p><strong>Coinbase:</strong> Más fácil para principiantes</p>
<p><strong>Kraken:</strong> Excelente seguridad</p>

<h2>Estrategia DCA (Dollar Cost Averaging)</h2>
<p>Invierte cantidades pequeñas regularmente ($50-$200/mes) en Bitcoin y Ethereum. Evita el timing del mercado.</p>

<h2>Errores a Evitar</h2>
<p>❌ FOMO (comprar en picos de precio)</p>
<p>❌ Trading con apalancamiento (leverage)</p>
<p>❌ Invertir en memecoins desconocidas</p>
<p>❌ Dejar tus cripto en exchanges (usa wallets)</p>

<h2>Educación Recomendada</h2>
<p>- Coursera: "Bitcoin and Cryptocurrency Technologies"</p>
<p>- YouTube: Canales educativos en español</p>
<p>- Libros: "The Bitcoin Standard"</p>

<h2>Expectativas Realistas</h2>
<p>Retornos anuales conservadores: 20-50%</p>
<p>Volatilidad: Caídas del 30-70% son normales</p>
<p>Horizonte: Mínimo 4 años (ciclos crypto)</p>

<h2>Consejo Final</h2>
<p>Las criptomonedas son una parte (10-20%) de tu portafolio diversificado, no todo tu patrimonio.</p>`,
    category: 'consejos',
    categoryName: 'Consejos',
    author: 'Miguel Ángel Torres',
    date: '2024-12-12',
    image: 'https://images.unsplash.com/photo-1621761191319-c6fb62004040?w=800&q=80',
    tags: ['criptomonedas', 'trading', 'inversión', 'bitcoin'],
    readTime: '10 min',
    featured: false
  }
];

// Helper functions
export const getFeaturedArticles = () => articles.filter(article => article.featured);

export const getArticlesByCategory = (categorySlug) => 
  articles.filter(article => article.category === categorySlug);

export const getArticleBySlug = (slug) => 
  articles.find(article => article.slug === slug);

export const searchArticles = (query) => {
  const lowerQuery = query.toLowerCase();
  return articles.filter(article => 
    article.title.toLowerCase().includes(lowerQuery) ||
    article.excerpt.toLowerCase().includes(lowerQuery) ||
    article.tags.some(tag => tag.toLowerCase().includes(lowerQuery)) ||
    article.content.toLowerCase().includes(lowerQuery)
  );
};

export const getLatestArticles = (limit = 6) => 
  [...articles].sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, limit);

export const getRelatedArticles = (currentArticleId, category, limit = 3) => 
  articles
    .filter(article => article.id !== currentArticleId && article.category === category)
    .slice(0, limit);
